import React, { useState } from 'react';
import api from '../services/api';
import {
  Box, Typography, FormControl, InputLabel, Select, MenuItem,
  TextField, Button, Alert, CircularProgress, InputAdornment, IconButton,
} from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

function PontoManual({ funcionarios, onPontoRegistrado }) {
  const [pessoaId, setPessoaId] = useState('');
  const [senha, setSenha] = useState('');
  const [showSenha, setShowSenha] = useState(false);
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState('');
  const [resultado, setResultado] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro('');

    if (!pessoaId || !senha) {
      setErro('Selecione seu nome e digite sua senha.');
      return;
    }

    setLoading(true);
    try {
      const response = await api.post('/ponto/manual', {
        pessoa_id: parseInt(pessoaId),
        senha,
      });

      const funcionario = funcionarios.find((f) => f.id === parseInt(pessoaId));
      setResultado({
        ...response.data,
        nome: funcionario?.nome || 'Funcionário',
      });

      if (onPontoRegistrado) onPontoRegistrado();
    } catch (err) {
      const msg = err.response?.data?.message || 'Erro ao registrar ponto manual.';
      setErro(msg);
    } finally {
      setLoading(false);
    }
  };

  const handleReiniciar = () => {
    setResultado(null);
    setPessoaId('');
    setSenha('');
    setErro('');
  };

  if (resultado) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 4 }}>
        <CheckCircleIcon color="success" sx={{ fontSize: 80 }} />
        <Typography variant="h5" sx={{ mt: 2 }}>{resultado.nome}</Typography>
        <Typography variant="h6" color="primary" sx={{ mt: 1 }}>
          {resultado.tipo === 'entrada' ? 'ENTRADA' : 'SAÍDA'} registrada!
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          {resultado.data_hora}
        </Typography>
        <Button variant="contained" sx={{ mt: 3 }} onClick={handleReiniciar} size="large">
          Novo registro
        </Button>
      </Box>
    );
  }

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      autoComplete="off"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        maxWidth: 400,
        mx: 'auto',
        py: 2,
      }}
    >
      <Typography variant="h6" gutterBottom>
        Registro manual de ponto
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3, textAlign: 'center' }}>
        Use esta opção se o reconhecimento facial não estiver funcionando.
      </Typography>

      {erro && (
        <Alert severity="error" sx={{ width: '100%', mb: 2 }} onClose={() => setErro('')}>
          {erro}
        </Alert>
      )}

      <FormControl fullWidth sx={{ mb: 2 }}>
        <InputLabel>Selecione seu nome</InputLabel>
        <Select
          value={pessoaId}
          label="Selecione seu nome"
          onChange={(e) => setPessoaId(e.target.value)}
        >
          {funcionarios.map((f) => (
            <MenuItem key={f.id} value={f.id}>
              {f.nome}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <TextField
        label="Senha"
        type={showSenha ? 'text' : 'password'}
        fullWidth
        value={senha}
        onChange={(e) => setSenha(e.target.value)}
        sx={{ mb: 3 }}
        onFocus={(e) => e.target.removeAttribute('readonly')}
        inputProps={{ autoComplete: 'new-password', readOnly: true }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={() => setShowSenha(!showSenha)} edge="end">
                {showSenha ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />

      <Button
        type="submit"
        variant="contained"
        size="large"
        fullWidth
        disabled={loading}
        startIcon={loading ? <CircularProgress size={20} /> : null}
      >
        {loading ? 'Registrando...' : 'Registrar ponto'}
      </Button>
    </Box>
  );
}

export default PontoManual;
